import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import Image from 'src/elements/image/image';
import LinkBranded from 'src/elements/links/Link.branded';
import Heading from 'src/elements/typography/heading';
import { FeaturedSingleContainer, FeaturedSingleImage, FeaturedSingleLink, FeaturedSingleText } from './featured.single.styles';

interface FeaturedSingleProps {
  title: string;
  slug: string;
  image: { gatsbyImageData: IGatsbyImageData };
}

const FeaturedSingle = (props: FeaturedSingleProps): JSX.Element => {

  return (
    <FeaturedSingleContainer>
      <FeaturedSingleImage>
        <Image childImageSharp={props.image.gatsbyImageData} alt={props.title} />
      </FeaturedSingleImage>
      <FeaturedSingleText>
        <Heading
          text={props.title}
          size="1.5em"
          weight="light"
          align="center"
        />
        <FeaturedSingleLink>
          <LinkBranded
            text="Read the Story"
            weight="normal"
            justify="center"
            url={`/case-studies/${props.slug}`}
          />
        </FeaturedSingleLink>
      </FeaturedSingleText>
    </FeaturedSingleContainer>
  )
}

export default FeaturedSingle;
